import moment from 'moment';
import { Day as DayType, getWeekNumber, getWeeksInMonth } from '../helpers';
import Day from './Day';

type MonthViewProps = {
  month: Date;
  selectedStart: Date | null;
  selectedEnd: Date | null;
  onSelectDate: (date: Date) => void;
  showMonthHeader?: boolean;
};

export const DAY_NAMES_MAP = {
  sv: ['Må', 'Ti', 'On', 'To', 'Fr', 'Lö', 'Sö'],
  en: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
} as const;

const MonthView = ({ month, selectedStart, selectedEnd, onSelectDate, showMonthHeader = false }: MonthViewProps) => {
  const weeks = getWeeksInMonth(month);
  const currentMonth = month.getMonth();

  return (
    <div className="w-full flex-shrink-0">
      {showMonthHeader && (
        <h2 className="bg-bg_secondary_neutral py-2xs px-sm text-l rounded-sm capitalize">
          {moment(month).format('MMMM')}
        </h2>
      )}
      {weeks.map((week, weekIdx) => {
        const hasCurrentMonthDays = week.some((day: DayType) => day.date.getMonth() === currentMonth);

        if (!hasCurrentMonthDays) return null;

        return (
          <div key={weekIdx} className="grid grid-cols-8">
            <span className="text-fg_secondary flex items-center justify-center text-xs" aria-label="Veckonummer">
              {`v.${getWeekNumber(week[0].date)}`}
            </span>
            {week.map((day: DayType) => (
              <Day
                key={day.date.toISOString()}
                day={day}
                selectedStart={selectedStart}
                selectedEnd={selectedEnd}
                onSelect={onSelectDate}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default MonthView;
